// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1ELuQ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__Jg1vk","obliqueLine":"membershipbadge_obliqueLine__1Bmgi"};